import {ofType} from 'redux-observable';
import {concat, EMPTY, iif, from, of, forkJoin} from 'rxjs';
import {ajax, AjaxError} from 'rxjs/ajax';
import {catchError, filter, mergeMap, timeout, map, debounceTime, delay} from 'rxjs/operators';
import {AnyAction} from 'redux';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as UIActions from '../../../actions/UIActions';
import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as MC from '../../../constants/MotorcreditConstants';
import {COUNTRIES} from '../../../constants/AppConstants';

import {
    mapStateToTurboCash
} from '../../../utils/WizardMXBodyMapper';
import {processApiError} from '../../../utils/ApiUtil';
import {addCredentialAndExecute} from '../../../utils/RetryUtil';
import {BankTarget} from '../../../types/mx/types';
import * as WizardActions from '../../../actions/WizardActions';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';
import * as ValidateConstant from '../../../constants/ValidateConstant';
import * as ErrorConstants from '../../../constants/ErrorConstants';
import {push} from 'connected-react-router';
import * as RoutesConstant from '../../../constants/RoutesConstant';
import {
    LoanApplicationTurboCashSummaryDTO
} from '../../../types/mx/creditoReal/epics';
import * as WizardResponseValidationUtils from '../../../utils/WizardResponseValidationUtils';
import {isEmpty} from '../../../../common/utils/ValidationUtils';
import {State} from '../../../types/mx/reducers';

export const goToTurboCashThanksEpic = action$ =>
    action$.pipe(
        ofType(WizardMXActions.GO_TO_TURBO_CASH_THANKS_ACTION.name),
        mergeMap(action => of(push(RoutesConstant.THANKS_TURBOCASH))));

export const saveTurboCashData = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.SAVE_TURBO_CASH_DATA_MX_ACTION.name),
        mergeMap((action: AnyAction) => {
            const state = state$.value;
            const token = state.turboCash.loanApplication.token;
            const urlBaseWithBank = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, BankTarget.TURBO_CASH);
            const url = `${urlBaseWithBank}/loan-applications/${token}/wizard-extra-data`;
            const body = mapStateToTurboCash(state);
            return concat(
                iif(
                    () => !action.isInterval,
                    of(UIActions.IS_LOADING_ACTION.action(WizardMXActions.SAVE_TURBO_CASH_DATA_MX_ACTION.name)),
                    EMPTY
                ),
                addCredentialAndExecute(headers => ajax.post(url, body, headers), state$.value).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        console.log('------------------WizardMXActions.RETURNED_FROM_API-------------------- ',
                            response);
                        return concat(
                            of(refreshTokenObs),
                            iif(
                                () => !action.isInterval,
                                of(UIActions.IS_LOADED_ACTION.action(
                                    WizardMXActions.SAVE_TURBO_CASH_DATA_MX_ACTION.name)
                                ),
                                EMPTY
                            ),
                            iif(
                                () => !action.isInterval,
                                of(WizardMXActions.GO_TO_TURBO_CASH_THANKS_ACTION.action()),
                                EMPTY
                            )
                        );
                    }),
                    catchError((error) => {
                        console.log('---------- EROROROROROOROR ::: ', error);
                        return processApiError([
                            UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.SAVE_TURBO_CASH_DATA_MX_ACTION.name
                            ),
                            UIActions.ERROR_GENERAL_ACTION.action(error, action, url, body, 'POST')
                        ])(error);
                    })
                )
            );
        })
    );

export const getLocationByPostalCodeEmployment = (action$, state$) =>
    action$.pipe(
        ofType(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.name),
        debounceTime(300),
        mergeMap((action: AnyAction) => {

            const defaultCatalog = WizardValidationUtils.defaultCatalog;
            const COUNT_AUTO_SELECTED = 1;
            const url = `${MC.MCC_URL(action.country)}/catalogs/locations/${action.postalCode}`;
            return iif(() => (action.error === null),

                concat(
                    of(UIActions.IS_LOADING_ACTION
                        .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.name)),
                    addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                        timeout(MC.TIMEOUT),
                        mergeMap(({response, refreshTokenObs}: any) => {
                            const dataResponse = response.response.data;

                            const calcColonyError = dataResponse.colony.length > COUNT_AUTO_SELECTED ?
                                ValidateConstant.ERROR_REQUIRED : null;

                            return concat(
                                of(refreshTokenObs),
                                of(WizardActions.CHANGE_EMPLOYMENT_STATES_TC_ACTION
                                    .action(dataResponse.state, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_CITY_TC_ACTION
                                    .action(dataResponse.city, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_TC_ACTION
                                    .action(dataResponse.municipality, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_COLONIES_TC_ACTION
                                    .action(dataResponse.colony, calcColonyError)),
                                of(UIActions.IS_LOADED_ACTION
                                    .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.name))
                            );
                        }),
                        catchError((error) => {
                            console.log('entraaa a error ON_CHANGE_POSTAL_CODE EMPLOYMENT-------------: ', error);
                            const errorIsNotFoundLocationError = Array.isArray(error) ?
                                error.includes(ErrorConstants.NOT_FOUND_LOCATION_ERROR) : false;

                            return processApiError([
                                errorIsNotFoundLocationError ?
                                    WizardMXActions.NOT_FOUND_LOCATION_ERROR_MX_ACTION.action() :
                                    UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET'),
                                UIActions.IS_LOADED_ACTION
                                    .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.name)
                            ])(error);
                        })
                    )
                )
                ,
                concat(
                    of(WizardActions.CHANGE_EMPLOYMENT_STATES_TC_ACTION
                        .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                    of(WizardActions.CHANGE_EMPLOYMENT_CITY_TC_ACTION
                        .action(defaultCatalog, null)),
                    of(WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_TC_ACTION
                        .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                    of(WizardActions.CHANGE_EMPLOYMENT_COLONIES_TC_ACTION
                        .action([], ValidateConstant.ERROR_REQUIRED)),
                )
            );
        })
    );

export const getLocationByPostalCodeReferencesEmployment = (action$, state$) =>
    action$.pipe(
        ofType(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION.name),
        debounceTime(300),
        mergeMap((action: AnyAction) => {

            const defaultCatalog = WizardValidationUtils.defaultCatalog;
            const COUNT_AUTO_SELECTED = 1;
            const url = `${MC.MCC_URL(action.country)}/catalogs/locations/${action.postalCode}`;
            return iif(() => (action.error === null),

                concat(
                    of(UIActions.IS_LOADING_ACTION
                        .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION.name)),
                    addCredentialAndExecute(headers => ajax.get(url, headers), state$.value).pipe(
                        timeout(MC.TIMEOUT),
                        mergeMap(({response, refreshTokenObs}: any) => {
                            const dataResponse = response.response.data;

                            const calcColonyError = dataResponse.colony.length > COUNT_AUTO_SELECTED ?
                                ValidateConstant.ERROR_REQUIRED : null;

                            return concat(
                                of(refreshTokenObs),
                                of(WizardActions.CHANGE_EMPLOYMENT_STATES_REFERENCES_TC_ACTION
                                    .action(action.index, dataResponse.state, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_CITY_REFERENCES_TC_ACTION
                                    .action(action.index, dataResponse.city, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_REFERENCES_TC_ACTION
                                    .action(action.index, dataResponse.municipality, null)),
                                of(WizardActions.CHANGE_EMPLOYMENT_COLONIES_REFERENCES_TC_ACTION
                                    .action(action.index, dataResponse.colony, calcColonyError)),
                                of(UIActions.IS_LOADED_ACTION
                                    .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION.name))
                            );
                        }),
                        catchError((error) => {
                            console.log('entraaa a error ON_CHANGE_POSTAL_CODE EMPLOYMENT-------------: ', error);
                            const errorIsNotFoundLocationError = Array.isArray(error) ?
                                error.includes(ErrorConstants.NOT_FOUND_LOCATION_ERROR) : false;

                            return processApiError([
                                errorIsNotFoundLocationError ?
                                    WizardMXActions.NOT_FOUND_LOCATION_ERROR_MX_ACTION.action() :
                                    UIActions.ERROR_GENERAL_ACTION.action(error, action, url, {}, 'GET'),
                                UIActions.IS_LOADED_ACTION
                                    .action(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_REFERENCES_TC_ACTION.name)
                            ])(error);
                        })
                    )
                )
                ,
                concat(
                    of(WizardActions.CHANGE_EMPLOYMENT_STATES_REFERENCES_TC_ACTION
                        .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                    of(WizardActions.CHANGE_EMPLOYMENT_CITY_REFERENCES_TC_ACTION
                        .action(defaultCatalog, null)),
                    of(WizardActions.CHANGE_EMPLOYMENT_MUNICIPALITY_REFERENCES_TC_ACTION
                        .action(defaultCatalog, ValidateConstant.ERROR_REQUIRED)),
                    of(WizardActions.CHANGE_EMPLOYMENT_COLONIES_REFERENCES_TC_ACTION
                        .action([], ValidateConstant.ERROR_REQUIRED)),
                )
            );
        })
    );

export const getLoanApplicationForSummaryMX = (action$, state$) =>
    action$.pipe(
        ofType(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION.name),
        filter(action => state$.value.profile.accessToken !== ''),
        mergeMap((action: AnyAction) => {
            const state: State = state$.value;
            const country: string = state.countrySelector.countrySelected;
            const urlBaseWithBank = MC.MCC_URL_WITH_BANK(COUNTRIES.MX.id, BankTarget.TURBO_CASH);
            const existToken = !isEmpty(state.turboCash.loanApplication.token);
            const token =
                existToken ? state.turboCash.loanApplication.token : action.token;
            const url = `${urlBaseWithBank}/loan-applications/${token}/summary-wizard`;
            return concat(
                of(UIActions.IS_LOADING_ACTION
                    .action(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION.name)),
                addCredentialAndExecute(headers => ajax.get(url, headers), state).pipe(
                    timeout(MC.TIMEOUT),
                    mergeMap(({response, refreshTokenObs}: any) => {
                        {
                            const dataResponse: LoanApplicationTurboCashSummaryDTO = response.response.data;

                            const continueHeaderFieldSummary = WizardResponseValidationUtils
                                .getContinueHeaderFieldSummary(dataResponse);
                            const applicantInfoFieldSummary = WizardResponseValidationUtils
                                .getPersonalApplicantFieldSummary(dataResponse);
                            const employmentInfoFieldSummary = WizardResponseValidationUtils
                                .getEmploymentInfoFieldSummary(dataResponse);
                            const referencesFieldSummary = WizardResponseValidationUtils
                                .getReferencesFieldSummary(dataResponse);
                            const documentGroupsFieldSummary = WizardResponseValidationUtils
                                .getDocumentGroupsFieldSummary(dataResponse);

                            return concat(
                                of(refreshTokenObs),
                                iif(
                                    () => !existToken,
                                    of(WizardActions.SET_LOAN_APPLICATION_TOKEN_TC_ACTION
                                        .action(token)),
                                    EMPTY
                                ),
                                iif(
                                    () => !isEmpty(employmentInfoFieldSummary.data.postalCode),
                                    of(WizardActions.CHANGE_EMPLOYMENT_POSTAL_CODE_TC_ACTION.action(16000, country)),
                                    EMPTY
                                ),
                                of(UIActions.IS_LOADED_ACTION
                                    .action(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION.name)),
                                of(WizardMXActions.SET_CONTINUE_HEADER_DATA_STATE_ACTION
                                    .action(continueHeaderFieldSummary)),
                                of(WizardMXActions.SET_APPLICANT_INFO_DATA_STATE_ACTION
                                    .action(applicantInfoFieldSummary, state)),
                                of(WizardMXActions.SET_EMPLOYMENT_INFO_DATA_STATE_ACTION
                                    .action(employmentInfoFieldSummary)),
                                of(WizardMXActions.SET_REFERENCES_DATA_STATE_ACTION
                                    .action(referencesFieldSummary)),
                                of(WizardMXActions.SET_DOCUMENTS_DATA_STATE_ACTION
                                    .action(documentGroupsFieldSummary)),
                            );
                        }
                    }),
                    catchError((error) => {
                        console.log('entraaa a error GOT_LOAN_APPLICATION_SUMMARY-------------: ', error);
                        const errorIsCompleteLoanApplication = Array.isArray(error) ?
                            error.includes(ErrorConstants.TURBO_CASH_COMPLETED_LOAN_APPLICATION_ERROR) : false;
                        const errorsResponse = [];
                        errorsResponse.push(
                            UIActions.IS_LOADED_ACTION.action(
                                WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_TC_ACTION.name)
                        );
                        if (errorIsCompleteLoanApplication) {
                            errorsResponse.push(WizardMXActions.GO_TO_TURBO_CASH_THANKS_ACTION.action());
                        }
                        return processApiError(errorsResponse)(error);
                    })
                )
            );
        })
    );
